// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qHKpu","fullView":"styles_fullView__7IS5J"};